import React from "react"
import CommentForm from "./comment-form"

function Comments({ post }) {
  return (
    <div className={"w-full mb-8"}>
      <div className={"mb-8"}>
        <h6 className={"mb-4 font-bold text-md lg:text-xl"}>
          What do you think about this story? Parents and Guardians, feel free to leave us a comment below and let
          us know!
        </h6>{" "}
        {post.comments && post.comments.nodes.length > 0 ? (
          <p>Comments will appear after they have been Approved. See what other kids say below the Comment Box:</p>
        ) : <p>Comments will appear after they have been Approved.</p>}
      </div>

      <CommentForm post={post} />
      {post.comments &&
        post.comments.nodes &&
        post.comments.nodes.map((comment, i) => (
          <div className={"comment mb-4 w-full "} key={`comment${i}`}>
            <div className={"font-bold text-primary"}>
              {comment.author.node.name}
            </div>
            <div className={"mb-4 text-xs"}>{comment.date}</div>
            <div
              style={{ fontStyle: "italic" }}
              dangerouslySetInnerHTML={{
                __html: `${comment.content}` || "No content here",
              }}
            />{" "}
          </div>
        ))}
    </div>
  )
}

export default Comments
